import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import { messages } from '../messages';

const BatchName = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId }));
  const fulfillmentPlanSetId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId: fulfillment?.fulfillmentPlanId,
      property: 'fulfillmentPlanSetId',
    }),
  );

  const fulfillmentPlanSetName = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanSetProperty(state, {
      fulfillmentPlanSetId,
      property: 'fulfillmentPlanSetName',
    }),
  );

  if (!fulfillmentPlanSetName) {
    return '';
  }

  return fulfillmentPlanSetName;
};

BatchName.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const batchName = {
  getMessageDescriptor: () => messages.batchName,
  name: <FormattedMessage {...messages.batchName} />,
  id: 'batchName',
  render: (data) => <BatchName fulfillmentId={data.id} />,
};
